import { render, staticRenderFns } from "./schedaProdotto.vue?vue&type=template&id=fc94806a&"
import script from "./schedaProdotto.vue.ts?vue&type=script&lang=ts&"
export * from "./schedaProdotto.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports